import { FC } from 'react'
import { Route, Switch } from 'react-router-dom'

import useAuth from '@hook/shared/use-auth'

import AcessDenied from '@view/AcessDenied'
import AdminManutencao from '@view/Admin/Manutencao'
import FollowUpAlert from '@view/Alerts/FollowUp'
import FollowUpReabAlert from '@view/Alerts/FollowUpReab'
import PurchaseAlert from '@view/Alerts/Purchase'
import PurchaseProcessView from '@view/Alerts/PurchaseProcess'
import CommercialBudget from '@view/Budget/Commercial'
import ConciliationBudget from '@view/Budget/Conciliation'
import ParametersBudget from '@view/Budget/Parameters'
import ReportBudget from '@view/Budget/Report'
import StoreBudget from '@view/Budget/Store'
import PurchaseScheduleDashboard from '@view/Dashboard/PurchaseSchedule'
import FollowUpFornecedorAprovacao from '@view/FollowUpFornecedor/Aprovacao'
import FollowUpFornecedorConfig from '@view/FollowUpFornecedor/Config'
import FollowUpFornecedorConfigComprador from '@view/FollowUpFornecedor/ConfigComprador'
import FollowUpFornecedorListagem from '@view/FollowUpFornecedor/Listagem'
import HelpCenter from '@view/HelpCenter'
import JobsPage from '@view/JobsPage'
import KpiLogistic from '@view/Kpi/Logistic'
import KpiRupture from '@view/Kpi/Rupture'
import KpiSales from '@view/Kpi/Sales'
import KpiStorage from '@view/Kpi/Storage'
import Maintenance from '@view/Maintence'
import MrpApproval from '@view/Mrp/Approval'
import MrpDistribution from '@view/Mrp/Distribution'
import MrpOportunity from '@view/Mrp/Oportunity'
import MrpPedidosCronograma from '@view/Mrp/PedidosCronograma'
import MrpPurchase from '@view/Mrp/Purchase'
import MrpReab from '@view/Mrp/Reab'
import MrpScheduledPurchase from '@view/Mrp/ScheduledPurchase'
import NotAuthorized from '@view/NotAuthorized'
import NotFoundAuth from '@view/NotFoundAuth'
import OptimizerConfigDefaultView from '@view/Optimizer/ConfigDefault'
import OptimizerStorange from '@view/Optimizer/Optimizer'
import FollowUpOtb from '@view/Otb/FollowUp'
import OtbPlan from '@view/Otb/Plan'
import Overview from '@view/Overview'
import ParamsCenter from '@view/ParamCenter'
import ConfigReabView from '@view/Parametrizations/ConfigReab'
import ParametrizationCurves from '@view/Parametrizations/Curves'
import ParametrizationIncrementSupplier from '@view/Parametrizations/IncrementSupplier'
import ParametrizationMinimumBilling from '@view/Parametrizations/MinimumBilling'
import PurchaseConfig from '@view/Parametrizations/PurchaseConfig/PurchaseConfig'
import ParametrizationRevision from '@view/Parametrizations/Revision'
import SettingsParametrizations from '@view/Parametrizations/Settings'
import ParametrizationSimilarProduct from '@view/Parametrizations/SimilarProduct'
import ParametrizationSupply from '@view/Parametrizations/Supply'
import WeeklyModifications from '@view/Parametrizations/WeeklyModifications'
import Profiles from '@view/Profiles'
import Users from '@view/Users'

import { ProtectedRoute } from './ProtectedRoute'
const AppRoutes: FC = () => {
  return (
    <Switch>
      {/* <Route path={'/not-authorized'}>
          <div>Nao Autorizado</div>
        </Route> */}
      {/* <Route path="*">
          <VerifyIfIsNotFound>
            <NotFoundAuth />
          </VerifyIfIsNotFound>
        </Route> */}
      <Route exact path="/not-authorized">
        <NotAuthorized />
      </Route>
      {/* <Route path={'/not-authorized'} element={<NotAuthorized />} /> */}
      <Route exact path="/">
        <ProtectedRoute>
          <Overview />
        </ProtectedRoute>
      </Route>
      <Route exact path="/not-found">
        <NotFoundAuth />
      </Route>

      <Route exact path="/overview">
        <ProtectedRoute>
          <Overview />
        </ProtectedRoute>
      </Route>
      <Route exact path="/usuarios">
        <RequireAuth regras={['Administrador', 'AnalistaPlanejamento']}>
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/perfil">
        <RequireAuth regras={['Administrador', 'AnalistaPlanejamento']}>
          <ProtectedRoute>
            <Profiles />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/paramscenter">
        <RequireAuth regras={['Administrador', 'AnalistaPlanejamento']}>
          <ProtectedRoute>
            <ParamsCenter />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/parametrizacao/faturamento-minimo">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',

            'Analista',
            'Assistente'
          ]}
        >
          <ProtectedRoute>
            <ParametrizationMinimumBilling />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/parametrizacao/revisao">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',
            'Analista',
            'Assistente'
          ]}
        >
          <ProtectedRoute>
            <ParametrizationRevision />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/parametrizacao/produto-similar">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',

            'Analista',
            'Assistente'
          ]}
        >
          <ProtectedRoute>
            <ParametrizationSimilarProduct />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/parametrizacao/configuracoes">
        <RequireAuth regras={['Administrador', 'AnalistaPlanejamento']}>
          <ProtectedRoute>
            <SettingsParametrizations />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/parametrizacao/curvas">
        <RequireAuth regras={['Administrador', 'AnalistaPlanejamento']}>
          <ProtectedRoute>
            <ParametrizationCurves />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/parametrizacao/reab">
        <RequireAuth
          regras={[
            'Administrador',
            'AnalistaPlanejamento',
            'AnalistaDistribuicao',
            'Parceiro'
          ]}
        >
          <ProtectedRoute>
            <ConfigReabView />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/parametrizacao/config/compra">
        <RequireAuth
          regras={['Administrador', 'AnalistaPlanejamento', 'AnalistaCompra']}
        >
          <ProtectedRoute>
            <PurchaseConfig />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/parametrizacao/abastecimento">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',
            'AnalistaComercial',
            'GerenteProduto',
            'Analista',
            'Loja',
            'Assistente',
            'GerenteLoja'
          ]}
        >
          <ProtectedRoute>
            <ParametrizationSupply />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/parametrizacao/incremento">
        <RequireAuth regras={['Administrador', 'AnalistaPlanejamento']}>
          <ProtectedRoute>
            <ParametrizationIncrementSupplier />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/parametrizacao/relatorio-modificacoes">
        <RequireAuth regras={['Administrador', 'AnalistaCompra']}>
          <ProtectedRoute>
            <WeeklyModifications />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/mrp/compra">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',

            'Analista',
            'Assistente'
          ]}
        >
          <ProtectedRoute>
            <MrpPurchase />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/mrp/compra/programada">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',
            'AnalistaCompra',

            'Analista',
            'Assistente'
          ]}
        >
          <ProtectedRoute>
            <MrpScheduledPurchase />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/mrp/distribuicao">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',

            'Analista',
            'Assistente'
          ]}
        >
          <ProtectedRoute>
            <MrpDistribution />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/mrp/reabastecimento-emergencial">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Analista',
            'Administrador',
            'AnalistaPlanejamento',
            'Assistente'
          ]}
        >
          <ProtectedRoute>
            <MrpReab />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/mrp/oportunidade">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',
            'GerenteProduto',
            'AnalistaComercial',
            'Analista',
            'Assistente'
          ]}
        >
          <ProtectedRoute>
            <MrpOportunity />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/mrp/aprovacao">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento'
          ]}
        >
          <ProtectedRoute>
            <MrpApproval />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/mrp/pedidos-cronograma">
        <RequireAuth
          regras={['Administrador', 'AnalistaPlanejamento', 'AnalistaCompra']}
        >
          <ProtectedRoute>
            <MrpPedidosCronograma />
          </ProtectedRoute>
        </RequireAuth>
      </Route>

      <Route exact path="/alertas/compra">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',
            'GerenteProduto',
            'AnalistaComercial',
            'Analista',
            'Assistente'
          ]}
        >
          <ProtectedRoute>
            <PurchaseAlert />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/alertas/follow-up">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',
            'GerenteProduto',
            'AnalistaComercial',
            'Analista',
            'GerenteLoja',
            'Assistente',
            'Loja'
          ]}
        >
          <ProtectedRoute>
            <FollowUpAlert />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/alertas/processamento-compra">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',
            'GerenteProduto',
            'AnalistaComercial',
            'Analista',
            'Assistente',
            'Loja'
          ]}
        >
          <ProtectedRoute>
            <PurchaseProcessView />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/alertas/follow-up-reab">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Logistica',
            'Administrador',
            'AnalistaPlanejamento',
            'GerenteLoja',
            'GerenteProduto',
            'AnalistaComercial',
            'Analista',
            'Assistente',
            'Loja'
          ]}
        >
          <ProtectedRoute>
            <FollowUpReabAlert />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/orcamento/relatorio">
        <RequireAuth
          regras={['Administrador', 'AnalistaPlanejamento', 'Financeiro']}
        >
          <ProtectedRoute>
            <ReportBudget />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/orcamento/comercial">
        <RequireAuth
          regras={['Administrador', 'AnalistaPlanejamento', 'Financeiro']}
        >
          <ProtectedRoute>
            <CommercialBudget />
          </ProtectedRoute>{' '}
        </RequireAuth>
      </Route>
      <Route exact path="/orcamento/conciliacao">
        <RequireAuth
          regras={['Administrador', 'AnalistaPlanejamento', 'Financeiro']}
        >
          <ProtectedRoute>
            <ConciliationBudget />
          </ProtectedRoute>{' '}
        </RequireAuth>
      </Route>
      <Route exact path="/orcamento/lojas">
        <RequireAuth
          regras={['Administrador', 'AnalistaPlanejamento', 'Financeiro']}
        >
          <ProtectedRoute>
            <StoreBudget />
          </ProtectedRoute>{' '}
        </RequireAuth>
      </Route>
      <Route exact path="/orcamento/Parametros">
        <RequireAuth
          regras={['Administrador', 'AnalistaPlanejamento', 'Financeiro']}
        >
          <ProtectedRoute>
            <ParametersBudget />
          </ProtectedRoute>{' '}
        </RequireAuth>
      </Route>

      {/* <Route exact path="/otb/plano">
          <RequireAuth regras={['Administrador',
            'AnalistaPlanejamento', 'Financeiro']}>
            <ProtectedRoute>
              <FollowUpAlert />
            </ProtectedRoute>{' '}
            <OtbPlan />
          </RequireAuth>
        </Route> */}
      <Route exact path="/otb/Acompanhamento">
        <RequireAuth
          regras={['Administrador', 'AnalistaPlanejamento', 'Financeiro']}
        >
          <ProtectedRoute>
            <FollowUpOtb />
          </ProtectedRoute>{' '}
        </RequireAuth>
      </Route>
      {/* <Route>
              <NotFound />
            </Route> */}
      <Route exact path="/manutencao">
        <ProtectedRoute>
          <Maintenance />
        </ProtectedRoute>{' '}
      </Route>
      <Route exact path="/dashboard/cronograma-semanal">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'Administrador',
            'AnalistaPlanejamento',
            'GerenteCategoria',
            'GerenteProduto',
            'Analista'
          ]}
        >
          <ProtectedRoute>
            <PurchaseScheduleDashboard />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/admin/manutencao">
        <RequireUserId userIds={ADMIN_MANUTENCAO_USER_IDS}>
          <ProtectedRoute>
            <AdminManutencao />
          </ProtectedRoute>
        </RequireUserId>
      </Route>
      {/* <Route exact path="/relatorio-geral">
              <Export />
            </Route> */}
      <Route exact path="/otbplano">
        <RequireAuth
          regras={['Administrador', 'AnalistaPlanejamento', 'Financeiro']}
        >
          <ProtectedRoute>
            <OtbPlan />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/kpi/ruptura">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',
            'GerenteCategoria',
            'Logistica',
            'GerenteProduto',
            'AnalistaComercial',
            'Analista',
            'Assistente',
            'Loja',
            'GerenteLoja'
          ]}
        >
          <ProtectedRoute>
            <KpiRupture />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/kpi/estoque">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',
            'GerenteCategoria',
            'GerenteProduto',
            'AnalistaComercial',
            'Analista',
            'Assistente',
            'Loja',
            'GerenteLoja'
          ]}
        >
          <ProtectedRoute>
            <KpiStorage />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/kpi/logistica">
        <RequireAuth regras={['Administrador', 'AnalistaPlanejamento']}>
          <ProtectedRoute>
            <KpiLogistic />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/kpi/vendas">
        <RequireAuth
          regras={[
            'Diretor',
            'AnalistaCompra',
            'AnalistaDistribuicao',
            'Parceiro',
            'Administrador',
            'AnalistaPlanejamento',
            'GerenteCategoria',
            'GerenteProduto',
            'AnalistaComercial',
            'Analista',
            'Assistente',
            'Loja',
            'GerenteLoja'
          ]}
        >
          <ProtectedRoute>
            <KpiSales />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/otimizador/estoque">
        <RequireAuth regras={['Administrador', 'AnalistaPlanejamento']}>
          <ProtectedRoute>
            <OptimizerStorange />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/otimizador/default">
        <RequireAuth regras={['Administrador', 'AnalistaPlanejamento']}>
          <ProtectedRoute>
            <OptimizerConfigDefaultView />
          </ProtectedRoute>
        </RequireAuth>
      </Route>

      <Route exact path="/job">
        <ProtectedRoute>
          <JobsPage />
        </ProtectedRoute>
      </Route>
      <Route exact path="/ajuda">
        <ProtectedRoute>
          <HelpCenter />
        </ProtectedRoute>
      </Route>
      <Route exact path="/follow-up-fornecedor">
        <RequireAuth
          regras={['Administrador', 'AnalistaCompra', 'AnalistaPlanejamento']}
          requireCompany={1000}
        >
          <ProtectedRoute>
            <FollowUpFornecedorListagem />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/follow-up-fornecedor/aprovacao">
        <RequireAuth
          regras={['Administrador', 'AnalistaCompra', 'AnalistaPlanejamento']}
          requireCompany={1000}
        >
          <ProtectedRoute>
            <FollowUpFornecedorAprovacao />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/follow-up-fornecedor/configuracoes">
        <RequireAuth
          regras={['Administrador', 'AnalistaCompra', 'AnalistaPlanejamento']}
          requireCompany={1000}
        >
          <ProtectedRoute>
            <FollowUpFornecedorConfig />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
      <Route exact path="/follow-up-fornecedor/config-compradores">
        <RequireAuth
          regras={['Administrador', 'AnalistaCompra', 'AnalistaPlanejamento']}
          requireCompany={1000}
        >
          <ProtectedRoute>
            <FollowUpFornecedorConfigComprador />
          </ProtectedRoute>
        </RequireAuth>
      </Route>
    </Switch>
  )
}
function RequireAuth({
  regras,
  requireCompany,
  children
}: {
  regras: string[]
  requireCompany?: number
  children: any
}) {
  const { role, companies } = useAuth()

  const roleOk = regras.includes(role)
  const companyOk =
    role === 'Administrador' ||
    requireCompany == null ||
    (companies ?? []).includes(requireCompany)

  return roleOk && companyOk ? children : <AcessDenied />
}

const ADMIN_MANUTENCAO_USER_IDS = ['234', '187']

function RequireUserId({
  userIds,
  children
}: {
  userIds: string[]
  children: any
}) {
  const { userId } = useAuth()

  return userIds.includes(userId) ? children : <AcessDenied />
}

// export default makeAuthenticator({
//   userManager,
//   placeholderComponent: <AuthLoading />
// })(AppRoutes)

export default AppRoutes
